import { Flame, Zap } from "lucide-react";

const STYLES = {
  breaking: { cls: "bg-[#DC2626] text-white", en: "Breaking", ta: "முக்கியம்", Icon: Zap },
  hot: { cls: "bg-[#EA580C] text-white", en: "Hot", ta: "சூடான", Icon: Flame },
  regular: { cls: "bg-white text-[#1D4ED8] border border-[#2563EB]", en: "Regular", ta: "செய்தி", Icon: null },
};

export const TrendBadge = ({ trend, lang = "en", testId }) => {
  const s = STYLES[trend] || STYLES.regular;
  const Icon = s.Icon;
  return (
    <span
      data-testid={testId || `trend-badge-${trend}`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.12em] rounded-sm ${s.cls}`}
    >
      {Icon && <Icon className="h-3 w-3" strokeWidth={2.5} />}
      {s[lang] || s.en}
    </span>
  );
};
